import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class CollectionSiteAttribute extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  value: string;
}
